import React from 'react';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../i18n';

const HeroSection = () => {
  const { t } = useLanguage();
  const scrollToDetails = () => {
    const element = document.getElementById('dettagli');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Full-screen photo */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/foto-hero.jpg')" }}
      />

      {/* Light wash: photo stays soft as a background */}
      <div className="absolute inset-0" style={{ background: 'hsl(0 0% 100% / 0.45)' }} />
      {/* Fade to white towards the bottom */}
      <div className="absolute inset-0 hero-overlay" />

      <div className="container mx-auto px-6 relative z-10 pt-28 pb-28">
        <div className="text-center max-w-2xl mx-auto">
          <p className="font-display text-sm uppercase tracking-[0.5em] text-foreground/70 mb-10 animate-fade-in">
            {t('hero.invited')}
          </p>

          <div className="animate-fade-in delay-200" data-testid="hero-names">
            <h1 className="font-script text-6xl md:text-7xl lg:text-8xl text-lavender mb-2 drop-shadow-sm">
              Jherli
            </h1>
            <div className="flex items-center justify-center gap-5 my-4">
              <span className="w-14 h-px bg-gradient-to-r from-transparent to-gold/60" />
              <span className="font-elegant text-3xl md:text-4xl text-gold italic">&</span>
              <span className="w-14 h-px bg-gradient-to-l from-transparent to-gold/60" />
            </div>
            <h1 className="font-script text-6xl md:text-7xl lg:text-8xl text-lavender drop-shadow-sm">
              Mirko
            </h1>
          </div>

          <p className="font-elegant text-xl md:text-2xl text-foreground/70 italic mt-10 animate-fade-in delay-400">
            &ldquo;{t('hero.quote')}&rdquo;
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={scrollToDetails}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 cursor-pointer group"
        aria-label="Scorri verso il basso"
        data-testid="scroll-down-button"
      >
        <span className="font-elegant text-sm italic text-foreground/60 group-hover:text-lavender transition-colors">
          {t('hero.scroll')}
        </span>
        <ChevronDown className="w-6 h-6 text-gold/70 animate-bounce group-hover:text-gold transition-colors" />
      </button>
    </section>
  );
};

export default HeroSection;
